/* Package imports */
import { useSelector, useDispatch } from 'react-redux';

/* Component imports */
import Modal from 'react-bootstrap/Modal';
import Button from "react-bootstrap/Button";

/* Utility imports */
import { globalFeedbackActions } from '../store/globalFeedback/globalFeedback';

/* Style imports */
import appStyles from '../App.module.css';


const FeedbackModal = (props) => {

    const globalFeedback = useSelector((state) => {
        return state.globalFeedback;
    });
    
    const dispatch = useDispatch();
    
    const handleClose = () => {
        dispatch(globalFeedbackActions.hideFeedback());
    };

    // Only show modal for critical errors (403 Forbidden, etc.)
    // Success messages and most errors now use toast notifications
    if (!globalFeedback.show) {
        return null;
    }

    return(
        <Modal
            show={globalFeedback.show}
            onHide={handleClose}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            style={{ zIndex: 1055 }}
        >
            <Modal.Header closeButton className="border-0 pb-2">
                <Modal.Title id="contained-modal-title-vcenter" className="d-flex align-items-center">
                    {globalFeedback.type === 'error' ? (
                        <>
                            <i className="mdi mdi-alert-circle me-2 text-danger" style={{ fontSize: '1.5rem' }}></i>
                            <span className={appStyles.dangerText}>Critical Error</span>
                        </>
                    ) : (
                        <>
                            <i className="mdi mdi-check-circle me-2 text-success" style={{ fontSize: '1.5rem' }}></i>
                            <span className={appStyles.successText}>Success</span>
                        </>
                    )}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="pt-0">
                <div className="mb-0">
                    {globalFeedback.message}
                </div>
            </Modal.Body>
            <Modal.Footer className="border-0 pt-2">
                <Button 
                    onClick={handleClose} 
                    variant={globalFeedback.type === 'error' ? 'danger' : 'success'}
                    style={{ borderRadius: '0.5rem', minWidth: '100px' }}
                >
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default FeedbackModal;